import React from 'react';
import CountUp from 'react-countup';
import { useInView } from 'react-intersection-observer';
import { Users, Globe, GraduationCap, Building } from 'lucide-react';

interface StatItemProps {
  icon: React.ElementType;
  value: number;
  suffix?: string;
  prefix?: string;
  label: string;
}

const StatItem: React.FC<StatItemProps> = ({ icon: Icon, value, suffix, prefix, label }) => {
  const [ref, inView] = useInView({ threshold: 0.3, triggerOnce: true });
  return (
    <div ref={ref} className="text-center">
      <div className="mx-auto w-12 h-12 rounded-xl bg-blue-500/20 border border-blue-400/30 flex items-center justify-center mb-4">
        <Icon className="h-5 w-5 text-blue-300" />
      </div>
      <div className="text-4xl sm:text-5xl font-extrabold text-white flex items-baseline justify-center">
        {prefix}
        {inView ? <CountUp end={value} duration={2.5} separator="," /> : '0'}
        {suffix}
      </div>
      <p className="mt-2 text-sm text-slate-300">{label}</p>
    </div>
  );
};

const Stats = () => {
  return (
    <section className="relative overflow-hidden py-24 bg-gradient-to-br from-slate-900 via-blue-900 to-slate-900">
      <div className="absolute -top-32 -right-32 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl" />
      <div className="absolute -bottom-32 -left-32 w-96 h-96 bg-indigo-500/20 rounded-full blur-3xl" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <span className="inline-flex items-center px-4 py-1.5 rounded-full bg-blue-500/10 border border-blue-400/30 text-blue-200 text-sm font-medium mb-5">
            Our Impact
          </span>
          <h2 className="text-3xl sm:text-4xl font-bold text-white">
            Fifteen years, thousands of exporters, one mission.
          </h2>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-10">
          <StatItem icon={Users} value={4000} suffix="+" label="Students Trained" />
          <StatItem icon={Globe} value={20} suffix="+" label="Countries Reached" />
          <StatItem icon={GraduationCap} value={95} suffix="%" label="Employment Rate" />
          <StatItem icon={Building} value={50} suffix="+" label="Corporate Partners" />
        </div>
      </div>
    </section>
  );
};

export default Stats;